module.exports = __webpack_public_path__ + "img/calendar.e421aab7.svg";